import LayoutNode, { getNodeStyleAttributeValue } from "../Definitions/LayoutNode";



export const CDNResolutions = {

    Large: "1020x680",
    Medium: "450x300",

}




export default function GetImageURLWithResolution(url:string,folderName:string){

    if(folderName && folderName.length>0 && url.includes("rackcdn.com")){// make sure its a cdn image and not unsplash

        let libraryIndex = url.indexOf("Library_");// only valid if it uses the new library system (older images that aren't compressed don't include this)

        if(libraryIndex>0){

            return url.substring(0,libraryIndex) + folderName +"/" +url.substring(libraryIndex,url.length);;

        }

    }


    return url;

}

// export function GetNodeHighestResolution(node:LayoutNode){
//     let res = "x";

//     for(let i = 0;i<3;i++){
//         let testRes = node.screenResolutions[i];
//         if(testRes && testRes.length>0){
          
//             if(testRes!=res){
//                 if(res == CDNResolutions.Medium && testRes == CDNResolutions.Large||res==="x"){
//                     res = testRes;
//                 }
//             }
//         }
//     }

//     if(res==="x") // unset just return blank
//         res = "";
//     return res;
// }

export function GetImageResolutionFromComponentSize(node:LayoutNode){

    let width = 0;
    let height = 0;

    for(let i = 0;i<3;i++){

        let evalWidth = getNodeStyleAttributeValue(node,i,"width");
        let evalHeight = getNodeStyleAttributeValue(node,i,"height");

        if(evalWidth.includes("100%")||evalHeight.includes("100%")){
            return CDNResolutions.Large;
        }

        if(evalWidth.length>0){
            let parse = parseInt(evalWidth.replace("px",""));
            if(parse>width){
                width = parse;
            }
        }
        if(evalHeight.length>0){
            let parse = parseInt(evalHeight.replace("px",""));
            if(parse>height){
                height = parse;
            }
        }

    }

    if(width>0||height>0){
       
        if(width>500||height>500)
            return CDNResolutions.Large;
        else
            return CDNResolutions.Medium;


    }

    return "";

}

